/** Paired giftee budget (dollars, step 5, min handle at least $10 gap below max handle). */

export const DEFAULT_GIFTEE_BUDGET_PAIR = Object.freeze({ min: 50, max: 120 });

function coerceNum(n, fallback) {
  return typeof n === "number" && Number.isFinite(n) ? n : fallback;
}

export function budgetPairFromGiftee(giftee) {
  const minRaw = coerceNum(giftee?.budgetMin, DEFAULT_GIFTEE_BUDGET_PAIR.min);
  const maxRaw = coerceNum(giftee?.budgetMax, DEFAULT_GIFTEE_BUDGET_PAIR.max);
  return clampBudgetPair(minRaw, maxRaw);
}

/** Keep min/max in valid wizard ranges relative to each other. */
export function clampBudgetPair(minRaw, maxRaw) {
  let min = Math.min(Math.max(Math.round(minRaw / 5) * 5, 10), 195);
  let max = Math.min(Math.max(Math.round(maxRaw / 5) * 5, 20), 200);
  min = Math.min(Math.max(min, 10), max - 10);
  max = Math.max(Math.min(max, 200), min + 10);
  return { min, max };
}

export function budgetPairReducer(state, action) {
  switch (action.type) {
    case "hydrate":
      return budgetPairFromGiftee({
        budgetMin: action.budgetMin,
        budgetMax: action.budgetMax,
      });
    case "setMin": {
      const raw =
        typeof action.value === "number"
          ? action.value
          : Number(action.target?.value);
      const rawValue = Number.isFinite(raw) ? raw : state.min;
      const nextMin = Math.min(Math.max(rawValue, 10), state.max - 10);
      return { ...state, min: Math.round(nextMin / 5) * 5 };
    }
    case "setMax": {
      const raw =
        typeof action.value === "number"
          ? action.value
          : Number(action.target?.value);
      const rawValue = Number.isFinite(raw) ? raw : state.max;
      const nextMax = Math.max(Math.min(rawValue, 200), state.min + 10);
      return { ...state, max: Math.round(nextMax / 5) * 5 };
    }
    default:
      return state;
  }
}
